module.exports = __webpack_public_path__ + "static/media/Pan330AC.63bbdbb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Pan330AC.jpg
// module id = 1060
// module chunks = 0